import { useEffect } from 'react';
import Raven from 'raven-js';
import { Flex } from 'foundations-components/components/Flex';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
function LoadingPage(props) {
  const {
    error,
    pastDelay
  } = props;
  let content = null;
  useEffect(() => {
    if (error instanceof Error) {
      Raven.captureException(error);
    }
  }, [error]);
  if (error) {
    content = /*#__PURE__*/_jsx(ErrorMessage, {
      type: "badRequest"
    });
  } else if (pastDelay) {
    content = /*#__PURE__*/_jsx(LoadingSpinner, {
      size: "medium"
    });
  }
  if (!content) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    children: content
  });
}
export default LoadingPage;